import { render, staticRenderFns } from "./cardPage.vue?vue&type=template&id=58c43c92&scoped=true&"
import script from "./cardPage.vue?vue&type=script&lang=js&"
export * from "./cardPage.vue?vue&type=script&lang=js&"
import style0 from "./cardPage.vue?vue&type=style&index=0&id=58c43c92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c43c92",
  null
  
)

export default component.exports